// noinspection JSDeprecatedSymbols
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ClinicHealthRecordMetaStore } from '../../../store/clinic-health-record-meta.store';

import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Injector, OnDestroy, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { startWith, Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-health-record-breadcrumb',
  standalone: true,
  imports: [BreadcrumbModule],
  templateUrl: './health-record-breadcrumb.component.html',
  styleUrl: './health-record-breadcrumb.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HealthRecordBreadcrumbComponent implements OnInit, OnDestroy {

  /* Store */

  readonly healthRecordMetaStore = inject(ClinicHealthRecordMetaStore);


  /* Services */

  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);


  /* Member Vars */

  breadcrumbMenuItems = signal<MenuItem[]>([]);
  healthRecordMetaSub$!: Subscription;
  private injector = inject(Injector);
  readonly home = {icon: 'fa-solid fa-home fa-xl', routerLink: '/hr-index'};
  static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';

  /* Lifecycle Hooks */



  /* Event Handlers */

  ngOnInit(): void {

    // Cannot create breadcrumbs until the health record meta is loaded, so create an
    // observable from the signal and subscribe to it.
    this.healthRecordMetaSub$ = toObservable(this.healthRecordMetaStore.healthRecordMeta,  {
      injector: this.injector,
    }).subscribe((meta) => {
      if(!meta) {
        return;
      }
      this.router.events.pipe(
        startWith(this.router),
      ).subscribe(() => {
        this.breadcrumbMenuItems.set(this.createBreadcrumbs(this.activatedRoute, '', []));
      });
    });

  }

  ngOnDestroy(): void {
    this.healthRecordMetaSub$.unsubscribe();
  }


  /* Instance Methods */

  // Builder method to create the breadcrumb item array
  createBreadcrumbs(
    route: ActivatedRoute,
    routerLink: string = '',
    breadcrumbs: MenuItem[] = []): MenuItem[] {

    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    breadcrumbs.unshift(
      { label: 'Health Records', routerLink: '/hr-index' },
      { label: `${this.healthRecordMetaStore.healthRecordMeta()!.patientName.toUpperCase()} - DOB ${new Date(this.healthRecordMetaStore.healthRecordMeta()!.patientDob).toLocaleDateString() }`, labelStyle: { 'font-weight': 'bold' } }
    );

    // noinspection LoopStatementThatDoesntLoopJS
    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        routerLink += `/${routeURL}`;
      }

      const label = child.snapshot.data[HealthRecordBreadcrumbComponent.ROUTE_DATA_BREADCRUMB];
      if(label !== null && label !== undefined) {
        breadcrumbs.push({label, routerLink});
      }

      return this.createBreadcrumbs(child, routerLink, breadcrumbs);
    }

    return this.breadcrumbMenuItems()
  }


}
